(function () {
  'use strict';

  function formatCurrency(value) {
    var rounded = Math.round(value);
    return '$' + rounded.toLocaleString('en-US');
  }

  function updateSliderFill(input) {
    var min = parseFloat(input.min) || 0;
    var max = parseFloat(input.max) || 100;
    var val = parseFloat(input.value) || 0;

    var pct = ((val - min) / (max - min)) * 100;

    input.style.setProperty('--slider-progress', pct + '%');
  }

  function initCalculator(root) {
    if (!root || root.dataset.calculatorInitialized) return;
    root.dataset.calculatorInitialized = 'true';

    // machineCost may arrive as a money string like "$5,000.00" (money metafield),
    // so strip any non-numeric characters before parsing.
    var machineCost = parseFloat(String(root.dataset.machineCost || '').replace(/[^0-9.]/g, '')) || 0;

    var inputs = {
      machines: root.querySelector('[data-input="machines"]'),
      wholesale: root.querySelector('[data-input="wholesale"]'),
      vendPrice: root.querySelector('[data-input="vendPrice"]'),
      vendsPerDay: root.querySelector('[data-input="vendsPerDay"]')
    };

    var outputs = {
      machines: root.querySelector('[data-output="machines"]'),
      wholesale: root.querySelector('[data-output="wholesale"]'),
      vendPrice: root.querySelector('[data-output="vendPrice"]'),
      vendsPerDay: root.querySelector('[data-output="vendsPerDay"]'),
      monthlyRevenue: root.querySelector('[data-output="monthlyRevenue"]'),
      monthlyProfit: root.querySelector('[data-output="monthlyProfit"]'),
      payback: root.querySelector('[data-output="payback"]'),
      annualRevenue: root.querySelector('[data-output="annualRevenue"]'),
      annualProfit: root.querySelector('[data-output="annualProfit"]')
    };

    // Set initial slider values from the data attributes (product metafields)
    if (inputs.wholesale) inputs.wholesale.value = root.dataset.wholesaleCost;
    if (inputs.vendPrice) inputs.vendPrice.value = root.dataset.vendPrice;
    if (inputs.vendsPerDay) inputs.vendsPerDay.value = root.dataset.vendsPerDay;

    function getValues() {
      var machines = parseFloat(inputs.machines.value) || 1;
      var wholesaleCost = parseFloat(inputs.wholesale.value) || 0;
      var vendPrice = parseFloat(inputs.vendPrice.value) || 0;
      var vendsPerDay = parseFloat(inputs.vendsPerDay.value) || 0;
      return { machines: machines, wholesaleCost: wholesaleCost, vendPrice: vendPrice, vendsPerDay: vendsPerDay };
    }

    function calculate() {
      var v = getValues();

      // Credit card fee: $0.20 + 3.5% of vend price
      var ccFee = 0.20 + (0.035 * v.vendPrice);

      // Margin derived from vend price minus wholesale cost (and cc fee), not entered directly
      var netProfitPerVend = v.vendPrice - v.wholesaleCost - ccFee;

      var monthlyVends = v.machines * v.vendsPerDay * 30;
      var monthlyRevenue = monthlyVends * v.vendPrice;
      var monthlyProfit = monthlyVends * netProfitPerVend;

      var annualRevenue = monthlyRevenue * 12;
      var annualProfit = monthlyProfit * 12;

      var totalMachineCost = machineCost * v.machines;
      var payback = monthlyProfit > 0 ? (totalMachineCost / monthlyProfit) : 0;

      return {
        monthlyRevenue: monthlyRevenue,
        monthlyProfit: monthlyProfit,
        annualRevenue: annualRevenue,
        annualProfit: annualProfit,
        payback: payback
      };
    }

    function render() {

      Object.keys(inputs).forEach(function (key) {
        if (inputs[key]) updateSliderFill(inputs[key]);
      });
    
      var v = getValues();
      var r = calculate();

      if (outputs.machines) {
        outputs.machines.textContent = v.machines + (v.machines === 1 ? ' Machine' : ' Machines');
      }
      if (outputs.wholesale) outputs.wholesale.textContent = '$' + v.wholesaleCost.toFixed(2).replace(/\.00$/, '');
      if (outputs.vendPrice) outputs.vendPrice.textContent = '$' + v.vendPrice.toFixed(2).replace(/\.00$/, '');
      if (outputs.vendsPerDay) outputs.vendsPerDay.textContent = v.vendsPerDay + ' vends';

      if (outputs.monthlyRevenue) outputs.monthlyRevenue.textContent = formatCurrency(r.monthlyRevenue);
      if (outputs.monthlyProfit) outputs.monthlyProfit.textContent = formatCurrency(r.monthlyProfit);
      if (outputs.annualRevenue) outputs.annualRevenue.textContent = formatCurrency(r.annualRevenue);
      if (outputs.annualProfit) outputs.annualProfit.textContent = formatCurrency(r.annualProfit);

      if (outputs.payback) {
        if (r.payback > 0) {
          var paybackMonths = Math.max(1, Math.round(r.payback));
          outputs.payback.textContent = '~' + paybackMonths + (paybackMonths === 1 ? ' month' : ' months');
        } else {
          outputs.payback.textContent = 'N/A';
        }
      }
    }

    Object.keys(inputs).forEach(function (key) {
      var el = inputs[key];
      if (el) el.addEventListener('input', render);
    });

    // "How this is calculated" toggle
    var noteToggle = root.querySelector('[data-note-toggle]');
    var note = root.querySelector('[data-note]');
    if (noteToggle && note) {
      noteToggle.addEventListener('click', function () {
        var expanded = noteToggle.getAttribute('aria-expanded') === 'true';
        noteToggle.setAttribute('aria-expanded', String(!expanded));
        note.hidden = expanded;
      });
    }

    // Add to cart
    var addToCartBtn = root.querySelector('[data-add-to-cart]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        var variantId = root.dataset.variantId;
        if (!variantId) return;

        var v = getValues();
        var textEl = addToCartBtn.querySelector('[data-add-to-cart-text]');
        var originalText = textEl ? textEl.textContent : '';

        addToCartBtn.disabled = true;
        if (textEl) textEl.textContent = 'Adding...';

        fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + 'cart/add.js'
          : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: v.machines }]
          })
        })
          .then(function (res) {
            if (!res.ok) return res.json().then(function (err) { throw err; });
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (textEl) textEl.textContent = 'Added!';
                var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
                window.location.href = cartUrl;
            })
          .catch(function (err) {
            console.error('Profit calculator — add to cart failed:', err);
            if (textEl) textEl.textContent = originalText;
            addToCartBtn.disabled = false;
            window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url) || '/cart';
          });
      });
    }

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-profit-calculator]').forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init when the section is added/edited in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-profit-calculator]');
    if (root) initCalculator(root);
  });
})();